import type { FunctionComponent } from "react";
import { SidebarList } from "./List";
import { SidebarSkeleton } from "./Skeleton";
import { useSidebarAtomValue } from "./sidebarAtom";

export const Sidebar: FunctionComponent = () => {
    const data = useSidebarAtomValue();

    if (!data || data.length === 0) return <SidebarSkeleton />;

    return <SidebarList items={data} />;
};
